export function parseError(error: any): string {
  // Axios error with response
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  
  if (error.response?.data?.error) {
    return error.response.data.error;
  }
  
  // Network error
  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
    return 'Unable to connect to server. Please check your connection.';
  }
  
  // Timeout error
  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
    return 'Request timed out. Please try again.';
  }
  
  // 401 Unauthorized
  if (error.response?.status === 401) {
    return 'Session expired. Please refresh the page.';
  }
  
  // 403 Forbidden
  if (error.response?.status === 403) {
    return 'Access denied. Please contact support.';
  }
  
  // 404 Not Found
  if (error.response?.status === 404) {
    return 'Resource not found. Please try again.';
  }
  
  // 500 Server Error
  if (error.response?.status >= 500) {
    return 'Server error. Please try again later.';
  }
  
  // Generic error
  return error.message || 'An unexpected error occurred. Please try again.';
}

export function shouldRetry(error: any): boolean {
  // Network errors can retry
  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED' || error.code === 'ETIMEDOUT') {
    return true;
  }
  
  // Server errors (5xx) can retry
  if (error.response?.status >= 500) {
    return true;
  }
  
  // Client errors (4xx) should not retry
  return false;
}

export function isConnectionError(error: any): boolean {
  return (
    error.code === 'ERR_NETWORK' ||
    error.code === 'ECONNREFUSED' ||
    error.code === 'ETIMEDOUT' ||
    error.code === 'ECONNABORTED' ||
    error.message?.includes('Network Error')
  );
}